import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRecommendations } from '../../../actions/classbook'
import { ClassbookContext } from '../../../utils/context'
import styles from '../styles.module.css'

export default function Recommendations({ active }) {
  const dispatch = useDispatch()
  const { formData } = useContext(ClassbookContext)
  const { students_list, expelled_students } = useSelector(state => state.classbook)

  useEffect(() => {
    const { year, period } = formData
    dispatch(getRecommendations(formData))
  }, [])
  return (
    <div >
      Recommendations
    </div>
  )
}
